import React from "react";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import PastorBio from "../components/PastorBio";
import DonationsSection from "../components/DonationsSection";
import ContactForm from "../components/ContactForm";

const Home = () => {
  return (
    <>
      <div style={{ height: "70vh", backgroundColor: "#1C1F4A", color: "white" }}>
        <HeroSection />
      </div>
      <div style={{ height: "5vh", backgroundColor: "#1C1F4A" }}></div>
      <AboutSection />
      <PastorBio />
      <DonationsSection />
      <ContactForm />
    </>
  );
};

export default Home;
